import { createFileRoute, getRouteApi } from '@tanstack/react-router';
import { useIntl } from 'react-intl';

import { useSnackbar } from '~/containers/Snackbar/SnackbarContext';
import { usePublisherMe } from '~/hooks/api/usePublisherMe';
import { usePublisherGetProfile } from '~/hooks/api/usePublisherGetProfile';
import { usePublisherSetProfile } from '~/hooks/api/usePublisherSetProfile';
import UserProfileSettingsForm from '~/containers/UserProfile/UserProfileSettingsForm';
import messages from '~/containers/UserProfile/messages';

const routeApi = getRouteApi('/user-profile/settings');

function UserProfileSettings() {
  const { publisherId } = routeApi.useSearch();
  const intl = useIntl();
  const { showSnackbar } = useSnackbar();

  const { data: publisherData, isLoading: isLoadingPublisher } = usePublisherMe(
    {
      enabled: !publisherId,
    }
  );

  const resolvedPublisherId = publisherId
    ? parseInt(publisherId, 10)
    : publisherData?.id || 0;

  const { data: profile } = usePublisherGetProfile(resolvedPublisherId, {
    enabled: !isLoadingPublisher || Boolean(publisherId),
  });

  const setPublisherProfileMutation = usePublisherSetProfile(
    resolvedPublisherId,
    {
      onSuccess() {
        showSnackbar({
          message: intl.formatMessage(messages.editUserProfileSuccess),
        });
      },
      onError() {
        showSnackbar({
          message: intl.formatMessage(messages.editUserProfileFailure),
        });
      },
    }
  );

  if (!profile) {
    return null;
  }

  return (
    <UserProfileSettingsForm
      isLoggedInUsersProfile={!publisherId}
      onSubmit={(profileValues) => {
        setPublisherProfileMutation.mutate({
          ...(profile || {}),
          deleteNotAssignedApplications:
            profileValues.deleteNotAssignedApplications || undefined,
          doNotSuggestRecurrentApplications:
            profileValues.doNotSuggestRecurrentApplications || undefined,
        });
      }}
      initialValues={profile || {}}
    />
  );
}

export const Route = createFileRoute('/user-profile/settings')({
  component: UserProfileSettings,
});
